// eslint-disable-next-line import/prefer-default-export
export const BreakPoints = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 1024,
	xl: 1366,
	xxl: 1700,
};
